import React, { Component } from 'react';
import {
    Table, Drawer, Divider, Dropdown, Popover, Breadcrumb, Menu, Col, Tag, Icon, message, Spin, List, Checkbox,
    Row, Button, Pagination, Modal, Form, Input, Select
} from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { api, app } from "../../app";
import utils from "../../utils";

const clear_receiver_data_name = React.createRef();
const clear_receiver_data_mobile = React.createRef();
// const clear_receiver_data_isTrue = React.createRef();
const clear_receiver_data_address = React.createRef();
const clear_current_province = React.createRef();
const clear_current_city = React.createRef();
const clear_current_area = React.createRef();
const Search = Input.Search
const Option = Select.Option

class UserAddress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: '',
            data_loding: true,
            teamList: [],
            total: 0,
            page: 1,
            showAddressBox: false,
            receiver_id: "",
            spec_list: [],
            spec_list2: [],
            showCodeBox: false, // 是否展示小程序码
            moveStatus: false, // 是否可以点击箭头进行图片切换
            moveWidth: '', // 是否可以点击箭头进行图片切换的距离样式
            specStatus: false, // 是否显示库存
            specStock: '', // 库存数量
            specSprice: '0.00', // 选中规格的价格
            spec_arr: [], // 选中的规格属性数组
            showAddressBox: false, // 是否显示地址modal
            receivingInfor: {},
            eAdressStatus: false, // 是否显示编辑（新增）收货地址弹框
            regions_all: '', // 省份值
            regions_province: '', // 省份值
            regions_city: '', // 城市值
            regions_area: '', // 地区值
            current_province: '', // 当前选中的省份
            current_city: '', // 当前选中的城市
            current_area: '', // 当前选中的区域
            receiver_data: '', // 选中的收货地址数据
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.getTokeni();
        this.dataSource();
        this.getDiqu()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据源
     */
    dataSource = () => {
        const _this = this;
        let params = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            page: this.state.page,
        }
        app.post(api.UserAddress, params).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                _this.setState({ data_loding: false });
                if (flag === 1) {
                    _this.setState({ teamList: utils.addArrayKey(data) });
                } else {
                    app.alert(msg, "error");
                }
            }
        });
    }

    setData = (obj) => app.setStateSync(this, obj)

    // 关闭收货信息
    closeTheAdress = () => {
        this.setData({
            showAddressBox: false,
        })
    }

    // 加载地区接口（省）
    getDiqu = async (e) => {
        let { flag, data, msg } = await app.post(api.SkillTrainRegions, { type: 3 })
        if (flag === 1) {
            let arr = [];
            if (data) {
                data.forEach((a, ai) => {
                    arr.push(a.region_name);
                })
                this.setData({
                    // current_city: '',
                    // current_area: '',
                    regions_all: data,
                    regions_province: arr,
                    regions_city: '',
                    regions_area: '',
                })
            }
        } else {
            app.alert(msg, 'warn')
        }
    }

    // 加载地区接口（市）
    getCity = (e) => {
        // console.log(e);
        const data = this.state.regions_all;

        if (data) {
            let arr = [];
            data.forEach((a, ai) => {
                if (e == a.region_name) {
                    // console.log("我进来啊了")
                    // console.log(a.sublevel);
                    // console.log("=====");
                    if (a.sublevel) {
                        a.sublevel.forEach((b, bi) => {
                            arr.push(b.region_name);
                        });
                    } else {
                        // console.log("==> "+a.region_name);
                        arr.push("");
                    }
                }
            })
            this.setData({
                regions_city: arr,
                regions_area: '',
                current_province: e,
                current_area: '',
                current_city: '',
            })
            // console.log(arr);
        }
    }

    // 加载地区接口（区）
    getArea = (e) => {
        const data = this.state.regions_all;
        const current_city = this.state.current_province;
        // console.log(data);
        // console.log(e);
        // console.log(this.state.current_city);

        if (data) {
            let arr = [];
            data.forEach((a, ai) => {
                // console.log(a.sublevel);
                if (current_city == a.region_name) {
                    // console.log(a.region_name);
                    // console.log(a.sublevel);
                    a.sublevel.forEach((b, bi) => {
                        if (e == b.region_name) {
                            b.sublevel.forEach((c, ci) => {
                                arr.push(c.region_name);
                            })
                        }

                    })
                }
            })
            this.setData({
                regions_area: arr,
                current_city: e,
                current_area: "",
            })
            // console.log(arr);
        }
    }

    // 选择地址
    selectAddress = (e) => {
        // console.log(e);
        let a = this.state.receivingInfor;
        let b = {
            malladdr: e.province + e.city + e.region + e.address,
            mobile: e.mobile,
            vname: e.name,
        }
        let c = { ...a, ...b };
        this.setData({
            receivingInfor: c,
            receiver_data: e || '',
        });
        // console.log(this.state.good_info.user)
        this.closeTheAdress();
    }

    // 设置地址
    setCurrentRegion = (a, b) => {
        console.log(b);
        if (a == 1) {
            this.getCity(b);
        } else if (a == 2) {
            this.getArea(b);
        } else if (a == 3) {
            this.setState({
                current_area: b
            });
        }
    }

    // 关闭编辑（新增地址）
    handleCodeEAdress = () => {
        this.setState({
            eAdressStatus: false,
            receiver_data: '',
            current_province: '',
            current_city: '',
            current_area: '',
        })
        // console.log(clear_receiver_data_isTrue);
        clear_receiver_data_name.current.setState({ value: "" });
        clear_receiver_data_mobile.current.setState({ value: "" });
        // clear_receiver_data_isTrue.current.setState({ value: "" });
        clear_receiver_data_address.current.setState({ value: "" });
        clear_current_province.current.setState({ value: "" });
        clear_current_city.current.setState({ value: "" });
        clear_current_area.current.setState({ value: "" });
        // console.log("关闭弹框");
        // console.log(this.state.receiver_data);
        
    }

    // 删除选中的地址
    delCurrentAddress = async (e) => {
        // console.log(e);
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            receiver_id: e.receiver_id || '',
        }
        const { flag, msg } = await app.post(api.delAddress, params)
        if (flag === 1) {
            message.success(msg);
            // 关闭收货信息弹窗
            this.closeTheAdress();
            this.dataSource();
        } else {
            message.error(msg);
        }
    }

    // 打开编辑（新增）收货地址弹框
    openEAddress = (b) => {
        if (b == '' || b == undefined) {
            this.setData({
                receiver_data: '',
                current_province: '',
                current_city: '',
                current_area: '',
                eAdressStatus: true,
                showAddressBox: false,
            })
        } else {
            
            let a = {
                receiver_data: b,
                current_province: b.province,
                current_city: b.city,
                current_area: b.district,
                eAdressStatus: true,
                showAddressBox: false,
            }
            console.log(a);
            this.setData({ ...a })            
        }
        // 加载地区接口
        // this.getDiqu();
        // console.log("打开弹框");
        // console.log(b);
        // console.log(this.state.receiver_data);
    }

    /**
* 获取token
* @returns {Promise<void>}
*/
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    render() {
        
        const columns = [
            {
                title: '收货人',
                dataIndex: 'receiver_name',
                key: 'receiver_name',
                width: '20%'
            },
            {
                title: '手机号码',
                dataIndex: 'receiver_mobile',
                key: 'receiver_mobile',
                width: '20%',
            },
            {
                title: '收货地址',
                dataIndex: 'receiver_address',
                key: 'receiver_address',
                width: '40%',
                render: (text, record) => <div>{record.province + record.city + record.district + record.receiver_address} <span style={{color: '#e4393c'}}>{ record.receiver_default == 1 ? '（默认收货地址）' : ''}</span> </div>,
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'xq',
                width: '20%',
                render: (text, record) => (
                    //{/*<span><Link to={"/ranks/detail/" + record.teamno} className="ranks_table_a">查看详情</Link></span>*/}
                    //<span><Link to={"/ranks/players/" + record.teamno} className="ranks_table_a">查看详情</Link></span>
                    <div>
                        <Button size='small' type="primary" style={{ marginRight: '8px' }} onClick={() => this.openEAddress(record)}>编辑</Button>
                        <Button size='small' onClick={() => this.delCurrentAddress(record)} type="danger">
                            删除
                        </Button>
                    </div>
                )
            },
        ], loading = this.state.data_loding,
            teamList = this.state.teamList,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            };

        const {
            showCodeBox,
            eAdressStatus,
            showAddressBox,
            receiver_data,
        } = this.state;

        const params = {
            name: this.state.receiver_data.receiver_name || '',
            num: this.state.receiver_data.receiver_mobile || '',
            address: this.state.receiver_data.receiver_address || '',
            isTrue: (this.state.receiver_data.receiver_default == 1 || this.state.receiver_data.receiver_default == true) ? 1 : 0,
        };

        // console.log(receiver_data);

        // 获取输入收货人姓名
        const getName = (e) => {
            // console.log(e.target.value)
            params.name = e.target.value;
            let a = this.state.receiver_data;
            let b = { ...a, receiver_name: e.target.value };
            this.setState({
                receiver_data: b
            });
        }

        // 获取输入收货人手机号
        const getNum = (e) => {
            // console.log(e.target.value);
            params.num = e.target.value;
            let a = this.state.receiver_data;
            let b = { ...a, receiver_mobile: e.target.value };
            this.setState({
                receiver_data: b
            });
        }

        // 获取输入详细收货地址
        const getMoreAddress = (e) => {
            // console.log(e.target.value)
            params.address = e.target.value;
            let a = this.state.receiver_data;
            let b = { ...a, receiver_address: e.target.value };
            this.setState({
                receiver_data: b
            });
        }

        // 设置是否默认
        const changeCheckbox = () => {
            // console.log(e);
            // console.log(e.target.checked);
            // params.isTrue = e.target.checked == true ? 1 : 0;
            let a = this.state.receiver_data;
            
            let b = { ...a, receiver_default: a.receiver_default == 1 ? 0 : 1 };
            this.setState({
                receiver_data: b
            });   
            // setTimeout(() => {
             
            // }, 500);
        }

        // 保存
        const save = async () => {
            // console.log(params);
            // console.log(this.state.current_province);
            // console.log(this.state.current_city);
            // console.log(this.state.current_area);
            let isTrue = true;
            // 检查收货人
            if (params.name == '') {
                message.warn("请填写收货人");
                isTrue = false;
            } else if (params.name.length > 25) {
                message.warn("收货人长度不能超过25位");
                isTrue = false;
            } else if (params.num.toString() === '') {
                message.warn("请填写手机号码");
                isTrue = false;
            } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(params.num)) {
                message.warn("请填写正确的手机号码");
                isTrue = false;
            } else if (this.state.current_province == '') {
                message.warn("请选择省份");
                isTrue = false;
            } else if (this.state.current_city == '') {
                message.warn("请选择城市");
                isTrue = false;
            } else if (this.state.current_area == '') {
                message.warn("请选择区域");
                isTrue = false;
            } else if (params.address == '') {
                message.warn("请填写详细地址");
                isTrue = false;
            }

            if (isTrue) {
                // console.log("调接口");

                let a = {
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                    receiver_name: params.name,
                    province: this.state.current_province,
                    city: this.state.current_city,
                    district: this.state.current_area,
                    receiver_address: params.address,
                    receiver_mobile: params.num,
                    receiver_default: params.isTrue ? 1 : 0,
                };
                let bpi = '';
                if (this.state.receiver_data.receiver_id != '' && this.state.receiver_data.receiver_id != undefined) {
                    a.receiver_id = this.state.receiver_data.receiver_id;
                    bpi = api.editAddress;
                } else {
                    bpi = api.addAddress;
                }
                // console.log(this.state.receiver_data.receiver_id);

                let { flag, data, msg } = await app.post(bpi, a)
                if (flag === 1) {
                    message.success(msg);
                    this.handleCodeEAdress();
                    this.dataSource();
                } else {
                    app.alert(msg, 'warn')
                }

            }
        }

        return (
            <div className="ranks_content" style={{ padding: '40px 0 0', maxWidth: '1190px', margin: '0 auto' }}>
                <div className="user-report-title" style={{ padding: '16px 0', fontSize: '19.2px', display: 'flex', justifyContent: 'space-between' }}>收货地址
                    <div style={{ fontSize: '12px', color: '#fff', display: 'inline-block', cursor: 'pointer', borderRadius: '4px', padding: '4px 8px', background: '#1890ff' }} onClick={() => this.openEAddress('')}>新增收货地址</div>
                </div>

                <Table className="ranks_table"
                    size="middle"
                    locale={locale}
                    columns={columns}
                    dataSource={teamList}
                    loading={loading}
                    pagination={false}
                    style={{
                        backgroundColor: '#fff'
                    }}
                />
                {/* <div style={{ width: '100%', textAlign: 'right', marginTop: '15px' }}>
                    <Pagination
                        size="small"
                        current={this.state.page}
                        // total={this.state.total}
                        pageSize={20}
                        // showTotal={(t) => `总数量：${t}`}
                        // onChange={this.hList}
                    />
                </div> */}
                {/* 编辑（新增地址） */}
                <Modal
                    title={this.state.receiver_data.receiver_id != '' && this.state.receiver_data.receiver_id != undefined ? '编辑收货信息' : '新增收货信息'}
                    visible={eAdressStatus}
                    width="420px"
                    closable={true}
                    onCancel={() => this.handleCodeEAdress()}
                    footer={<Button type="primary" style={{ width: '100%' }} onClick={() => save()}>保存</Button>}
                >
                  
                    <div
                        style={{
                            position: 'relative',
                            zIndex: '89',
                        }}
                    >
                        {/* {JSON.stringify(this.state.receiver_data)} */}
                        <div className='item'>
                            <div className="title" style={{ padding: '10px 0' }}>收货人</div>
                            <div className="content">
                                <Input ref={clear_receiver_data_name} value={params.name} onChange={(e) => getName(e)} defaultValue={receiver_data.receiver_name} />
                            </div>
                        </div>
                        <div className='item'>
                            <div className="title" style={{ padding: '10px 0' }}>手机号码</div>
                            <div className="content">
                                <Input ref={clear_receiver_data_mobile} value={params.num} onChange={(e) => getNum(e)} defaultValue={receiver_data.receiver_mobile} />
                            </div>
                        </div>
                        <div className='item'>
                            <div className="title" style={{ padding: '10px 0' }}>地区</div>
                            <div className='item2333'>
                                <div className="content xoxoicon"
                                >
                                    <Select
                                        style={{ minWidth: '140px' }}
                                        value={this.state.current_province != '' ? this.state.current_province : '选择省份'}
                                        // defaultValue={receiver_data.province != '' ? receiver_data.province : (this.state.current_province != '' ? this.state.current_province : '选择省份')}
                                        ref={clear_current_province}
                                        onChange={(e) => this.setCurrentRegion(1, e)}
                                    >
                                        {
                                            (this.state.regions_province || []).map((e, i) => {
                                                return (
                                                    <Option value={e} key={i}>{e}</Option>
                                                )
                                            })
                                        }

                                    </Select>
                                    <Select
                                        // defaultValue={this.state.current_city || '选择城市'}
                                        style={{ minWidth: '100px' }}
                                        value={this.state.current_city != '' ? this.state.current_city : '选择城市'}
                                        onChange={(e) => this.setCurrentRegion(2, e)}
                                        ref={clear_current_city}
                                    >
                                        {
                                            (this.state.regions_city || []).map((e, i) => {
                                                return (
                                                    <Option value={e} key={i}>{e}</Option>
                                                )
                                            })
                                        }

                                    </Select>

                                    <Select
                                        // defaultValue={this.state.current_area || '选择区域'}
                                        style={{ minWidth: '100px' }}
                                        // defaultValue={receiver_data.region != '' ? this.state.current_area : '选择区域'}
                                        value={this.state.current_area != '' ? this.state.current_area : '选择区域'}
                                        ref={clear_current_area}
                                        onChange={(e) => this.setCurrentRegion(3, e)}
                                    >
                                        {
                                            (this.state.regions_area || []).map((e, i) => {
                                                return (
                                                    <Option value={e} key={i}>{e}</Option>
                                                )
                                            })
                                        }

                                    </Select>
                                    {/* <div className='iconfont icon-drop_down' style={{ transform: 'scale(0.3)', position: 'relative', top: '1px' }}></div> */}
                                </div>
                            </div>
                        </div>

                        <div className='item'>
                            <div className="title" style={{ padding: '10px 0' }}>详细地址</div>
                            <div className="content">
                                <Input
                                    value={params.address}
                                    defaultValue={receiver_data.receiver_address}
                                    ref={clear_receiver_data_address}
                                    onChange={(e) => getMoreAddress(e)} />
                            </div>
                        </div>

                        <div className="item" style={{ marginTop: '8px' }}>
                            <div className="content">
                                <div onClick={()=>changeCheckbox()} style={{display: 'flex', alignItems: 'center'}}>
                                    <div style={{width: '16px',height: '16px',border: '1px solid #1890ff',alignItems: 'center',justifyContent: 'center', borderRadius: '2px', display: 'inline-block',backgroundColor: receiver_data.receiver_default == 1 ? '#1890ff' : '',marginRight: '10px'}}>
                                        <span style={{display: receiver_data.receiver_default == 1 ? 'inline-block' : 'none', background: '#fff', width: '2px', height: '10px',transform: 'rotate(30deg)',position: 'relative',left: '8px',top: '-4px',}}></span>
                                        <span style={{display: receiver_data.receiver_default == 1 ? 'inline-block' : 'none', background: '#fff', width: '2px', height: '6px',transform: 'rotate(317deg)',position: 'relative',left: '2px',top: '-4px',
                                    }}></span>
                                    </div>
                                    {receiver_data.receiver_default == 1 ? '已设为默认' : '设为默认'}
                                </div>
                                {/* <Checkbox
                                    ref={clear_receiver_data_isTrue}
                                    // defaultChecked={receiver_data.receiver_default == 1 || receiver_data.receiver_default == true}
                                    value={receiver_data.receiver_default == 1 || receiver_data.receiver_default == true}
                                    onChange={(e) => changeCheckbox(e)}>
                                    {receiver_data.receiver_default == 1 || receiver_data.receiver_default == true ? '已设为默认' : '设为默认'}
                                </Checkbox > */}
                            </div>
                        </div>

                    </div>
                </Modal>

            </div>
        );
    }
}

export default UserAddress;



// WEBPACK FOOTER //
// ./src/routes/playerInfo/UserAddress.jsx